import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

import { BehaviourListModel } from '../../../../../../../core/models/common.models';

@Component({
  selector: 'app-define-behavior-wizard-antecedents-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzCheckboxModule,
    NzInputModule,
    NzDividerModule,
  ],
  templateUrl: './define-behavior-wizard-antecedents-step.component.html',
  styleUrl: './define-behavior-wizard-antecedents-step.component.scss',
})
export class DefineBehaviorWizardAntecedentsStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() behaviourAntecedentList: BehaviourListModel[] = [];
  @Input() antecedentDescriptionControls: FormGroup[] = [];
  @Input() onCheckboxChange!: (
    controlName: string,
    checked: boolean,
    value: number
  ) => void;
  @Input() onAntecedentChange!: (
    checked: boolean,
    category: BehaviourListModel
  ) => void;
  @Input() onControlInputChange!: (
    event: Event,
    control: AbstractControl | null
  ) => void;
  @Input() getBehaviorAntecedentTitle!: (id: number) => string;
  @Input() trackById!: (index: number, item: { id: number }) => number;
  @Input() trackByIndex!: (index: number) => number;
}
